import { FileStatus } from "filepond";

export default function valid(value) {
	return (
		!Array.isArray(value) ||
		value.some(({ status }) => status !== FileStatus.LOAD_ERROR)
	);
}
